export default class {
  #targetInputField;

  constructor(targetInputField) {
    this.#targetInputField = targetInputField;
  }

  write({ editor }) {
    this.#targetInputField.value = editor.getHTML();
    this.#targetInputField.dispatchEvent(new Event('input', { bubbles: true }));
  }

  read() {
    return this.#targetInputField.value;
  }
}
